import { useContext, useEffect, useRef } from "react";
import { UseFormGetValues } from "react-hook-form";

import { DEFAULT_PRESCRIPTION_INFO } from "src/constants/cases";
import { AuthContext } from "src/context/authContext";

import { AddCaseProps } from "src/pages/addCase/types";
import { PrescriptionObjKeyProps } from "src/types/case";




export function usePageTrackingAndStorage(fetchLatestData?: UseFormGetValues<AddCaseProps>, isDirty?: boolean, step?: number, isFormSubmitted?: boolean) {
  const { isUserAuthorized } = useContext(AuthContext)

  const formSubmissionRef = useRef<boolean>()
  const stepRef = useRef<number>(1)
  const isDirtyRef = useRef<boolean>()
  const isUserRef = useRef<boolean>()


  const isPrescriptionAttributesUpdated = () => {
    if(fetchLatestData) {
      const updatedPrescriptionValues = fetchLatestData("prescription_attributes")
      return Object.keys(updatedPrescriptionValues).some((key: unknown) => {
        if (key === "diagnosis_code" || key === "nerves")
          return false
        else
          return updatedPrescriptionValues[key as PrescriptionObjKeyProps] !== DEFAULT_PRESCRIPTION_INFO[key as PrescriptionObjKeyProps]
      });
    }
  }

  useEffect(() => {
    // Handle page refresh / close
    const handleBeforeUnload = () => {
      if (typeof isUserRef.current === "boolean" && isUserRef.current === true) {
        if (typeof formSubmissionRef.current === "boolean" && formSubmissionRef.current === false && fetchLatestData) {
          if (isPrescriptionAttributesUpdated() || isDirtyRef.current)
            localStorage.setItem('newCase', JSON.stringify({ newData: fetchLatestData(), step: stepRef.current }))
        }
      }
    }

    window.addEventListener('beforeunload', handleBeforeUnload)
    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload)
      // Save to localStorage on route change
      handleBeforeUnload()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    formSubmissionRef.current = isFormSubmitted
  }, [isFormSubmitted])

  useEffect(() => {
    if(step) stepRef.current = step
  }, [step])

  useEffect(() => {
    isDirtyRef.current = isDirty
  }, [isDirty])

  useEffect(() => {
    isUserRef.current = isUserAuthorized
  }, [isUserAuthorized])


  // ✅ Reset function for logout
  const resetTracking = () => {
    formSubmissionRef.current = undefined;
    stepRef.current = 1;
    localStorage.removeItem("newCase");
  };

  return { resetTracking };
};
